import angular from 'angular';
import uiRouter from 'angular-ui-router';
import step1Component from './step1.component';

let step1Module = angular.module('step1', [
	uiRouter
])

	.config(($stateProvider, $urlRouterProvider) => {
		"ngInject";

		$stateProvider
			.state('home.contributor.step1', {
				url: '/step-1',
				component: 'step1'
			});
	})

	.component('step1', step1Component)

	.name;

export default step1Module;



// WEBPACK FOOTER //
// ./client/app/components/home/contributor/step1/step1.js